import { Component, OnInit } from '@angular/core';

import { AccountInformationService } from './account-information.service';
import { Customer } from './../../shared/models/customer';
import { Status } from './../../shared/enums/status';

@Component({
  selector: 'account-information',
  template: require('./account-information.component.html'),
  styles: [require('./account-information.component.scss')],
  providers: [AccountInformationService]
})
export class AccountInformationComponent implements OnInit {

  showUpdateCard: boolean = false;
  showUpdatePlan: boolean = false;

  public Status = Status;
  status: Status;

  constructor(private service: AccountInformationService) {
  }

  ngOnInit() {
    this.getCustomerInfo();
  }

  getCustomerInfo() {
    this.status = Status.Loading;
    this.service.getCustomer()
      .then(this.displayCustomerInfo.bind(this))
      .catch((err) => {
        this.status = Status.Error;
      });
  }

  displayCustomerInfo(customer: Customer) {
    this.status = Status.Loaded;
  }

  openUpdateCard() {
    this.showUpdateCard = true;
  }

  closeUpdateCard() {
    this.showUpdateCard = false;
    this.getCustomerInfo();
  }

  openUpdatePlan() {
    this.showUpdatePlan = true;
  }

  closeUpdatePlan() {
    this.showUpdatePlan = false;
    this.getCustomerInfo();
  }

  closeCancelPopup() {
    this.service.showCancel = false;
    this.service.cancelSuccess = false;

    this.service.status = '';

    this.ngOnInit();
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/account/account-information/account-information.component.ts